module.exports = {
  __depends__: [
    require(384),
    require(398)
  ],
  bpmnReplace: [ 'type', require(77) ]
};
